/** Kbd: a key hint. `modKey("K")` reads "⌘K" on a Mac and "Ctrl K" elsewhere. */
import type { ReactNode } from "react";
import { cx } from "./cx";

const IS_MAC = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);

export const modKey = (key: string): string => (IS_MAC ? `⌘${key}` : `Ctrl ${key}`);

const TONE = {
  /** On a light surface. */
  light: "border-border bg-secondary text-kbd-foreground",
  /** On the dark fill (a primary button): the key in the button's own ink, no tile (the reference's search hint has none). */
  dark: "border-transparent text-primary-foreground",
};

export function Kbd({ children, tone = "light", className }: { children: ReactNode; tone?: keyof typeof TONE; className?: string }) {
  return <kbd className={cx("inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded border-hair px-1 font-sans text-caption font-medium leading-none", TONE[tone], className)}>{children}</kbd>;
}
